import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllCommodityTypeService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allCommodityTypeService = useQuery({
    queryKey: [...CACHE_KEYS.COMMODITY, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.COMMODITY,
        searchParams: {
          page,
          "filter[name]": debouncedQuery,
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allCommodityTypeService },
    states: { searchQuery, setSearchQuery },
  };
};
